import { IDEMPOTENCY_KEY_HEADER } from 'utils/api/constants';

/**
 * The header that lets the API recognise a repeat of one booking intent.
 *
 * @author Milton Filho
 */

/**
 * A key identifies an *intent*, not a transmission.
 *
 * That distinction is the whole guarantee. Minted where the request is
 *   transmitted, it would be fresh on every replay and the backend would see
 *   each one as a new booking — which is the duplication it exists to stop, with
 *   a header attached. So the key is decided once, where the therapist's intent
 *   is captured, and carried by every attempt at it.
 *
 * For a queued booking that is already solved: `handleOfflineBooking` mints the
 *   queue item's `id` with `randomUUID()` when the intent is enqueued, and it is
 *   persisted with the item and reused on every replay. Passing it here needs no
 *   new field — which also means queue items written by earlier builds carry a
 *   usable key, with no schema version to check.
 *
 * Absent key yields no header rather than an empty one, so a caller with nothing
 *   to promise says nothing.
 */
export const getIdempotencyHeaders = (
  key: string | undefined,
): Record<string, string> => (key ? { [IDEMPOTENCY_KEY_HEADER]: key } : {});
